query BunnyAccountLibraries($accountApiKey: String!) {
  bunnyAccountLibraries(accountApiKey: $accountApiKey) {
    id
    name
    videoCount
    replicationRegions
  }
}
